import React, { useEffect, useRef } from "react";
import Button from "../../primitives/button";
import { useDialogFocusRestoration } from "../use-dialog-focus";
import "./confirm-action-dialog.css";

export default function ConfirmActionDialog({
  isOpen,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onClose,
  submitting = false,
}) {
  const containerRef = useRef(null);
  useDialogFocusRestoration(isOpen, containerRef);

  useEffect(() => {
    if (!isOpen) return undefined;

    const onEscape = (event) => {
      if (event.key === "Escape" && !submitting) {
        onClose?.();
      }
    };

    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", onEscape);
    return () => {
      document.body.style.overflow = "unset";
      document.removeEventListener("keydown", onEscape);
    };
  }, [isOpen, onClose, submitting]);

  if (!isOpen) return null;

  return (
    <div
      className="confirmActionModal__overlay"
      onClick={() => (!submitting ? onClose?.() : null)}
    >
      <div
        className="confirmActionModal__container"
        onClick={(event) => event.stopPropagation()}
        ref={containerRef}
        tabIndex={-1}
        role="dialog"
        aria-modal="true"
      >
        <button
          type="button"
          aria-label="Close confirmation dialog"
          className="confirmActionModal__close"
          onClick={onClose}
          disabled={submitting}
        >
          ✕
        </button>

        <h2 className="confirmActionModal__title">{title}</h2>
        <p className="confirmActionModal__message">{message}</p>

        <div className="confirmActionModal__actions">
          <Button
            variant="ghost"
            type="button"
            onClick={onClose}
            disabled={submitting}
          >
            {cancelLabel}
          </Button>
          <Button
            variant="primary"
            type="button"
            onClick={onConfirm}
            disabled={submitting}
          >
            {submitting ? "Please wait..." : confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
